import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ApiManagersBusinessSectionsAiBusinessSectionContextsCreateResponseType } from "../../types";

type RequestDataType = {
  businessSectionId: string;
  body: {
    context: string;
  };
};

const request = ({ businessSectionId, body }: RequestDataType) => {
  return new ApiClient()
    .post<ApiManagersBusinessSectionsAiBusinessSectionContextsCreateResponseType>(
      `/api/managers/business_sections/${businessSectionId}/ai_business_section_contexts`,
      {
        aiBusinessSectionContext: body,
      },
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagersBusinessSectionsAiBusinessSectionContextsCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiManagersBusinessSectionsAiBusinessSectionContextsCreateResponseType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
